module.exports = __webpack_public_path__ + "img/girl-intervue.3935e97.jpg";